import share from '@devices/settings/device_settings/share.js';
import wave_application_settings from '@devices/settings/device_settings/wave_application_settings.js';
import wave_device_settings from '@devices/settings/device_settings/wave_device_settings.js';

export default {
	name: 'ShellyZwaveInput',
	friendly_name: 'Z-Wave Input',
	family: 'inputs_reader',
	isPM: false,
	gen: 'GZ',
	modes: {
		inputs_reader: {
			availableViews: ['basic', 'advanced'],
			channels: 4,
			notifications: ['offline', 'device_problem'],
			settings: [wave_application_settings, share, wave_device_settings],
		},
	},
};
